import { Badge, Tooltip } from '@mantine/core'
import { useIntl } from 'react-intl'

type OcrBadgeProps = {
  tag: 'whitelist' | 'blacklist' | null
  compact?: boolean
}

export const OcrBadge = ({ tag, compact = false }: OcrBadgeProps) => {
  const intl = useIntl()

  const message = intl.formatMessage({
    id:
      tag === 'whitelist'
        ? 'events.ocr.badge.whitelist'
        : 'events.ocr.badge.blacklist'
  })

  if (!tag) {
    return null
  }

  return (
    <Tooltip label={message} disabled={!compact}>
      <Badge color={tag === 'whitelist' ? 'green' : 'red'} circle={compact}>
        {/* The 'compact' prop determines if the badge should display only the first character of the message or the full message. */}
        {compact ? message.charAt(0) : message}
      </Badge>
    </Tooltip>
  )
}
